import { render } from "./JobDetails.vue?vue&type=template&id=299de43d&scoped=true"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=299de43d&scoped=true&lang=css"

import exportComponent from "/Users/jonathanhuttmann/Downloads/adancareers/adancareers_vue/gebeya/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299de43d"]])

export default __exports__